import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { COLOR, FIXED_INDENTS } from 'vars/index'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
} from '../Button.h'

export interface ISecondaryButtonProps extends IButtonProps {}

export const SecondaryButton = ({
  title = '',
  corners = ButtonCorners.CORNERS_10,
  paddings = [FIXED_INDENTS.INDENT_20, FIXED_INDENTS.INDENT_60],
  colorDefault = ButtonColors.COLOR_SECONDARY,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.BASE_MAIN_DEFAULT,
  backgroundColorHovered = COLOR.SURFACE_LIGHT_2,
  backgroundColorPressed = COLOR.BASE_MAIN_PRESSED,
  backgroundColorDisabled = COLOR.DISABLED,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.Button2,
  fluid = ButtonFluid.None,
  ...rest
}: ISecondaryButtonProps): JSX.Element | null =>
  title ? (
    <Button
      corners={corners}
      paddings={paddings}
      colorDefault={colorDefault}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorHovered={backgroundColorHovered}
      backgroundColorPressed={backgroundColorPressed}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      font={font}
      fluid={fluid}
      title={title}
      {...rest}
    />
  ) : null
